const birds = [
	'Woodpecker',
	'Pigeon',
	'Peacock',
	'Rooster',
	'Swallow',
	'Seagull',
	'Quail',
	'Duck',
	'Pelican',
	'Magpie',
	'Parrot',
	'Turkey',
	'Crane',
	'Kingfisher',
	'Hummingbird',
	'Sparrow',
	'Cormorant',
	'Ostrich',
	'Crow',
	'Raven',
	'Dove',
	'Hen',
	'Nightingale',
	'Eagle',
	'Swan',
	'Penguin',
	'Flamingo',
	'Goose',
	'Cuckoo',
	'Owl',
	'Hawk',
	'Partridge',
	'Goldfinch',
	'Robin',
	'Finch',
	'Frigatebird',
	'Sandpiper',
	'Stork',
	'Ibis',
	'Hornbill',
	'Bulbul',
	'Skylark',
	'Canary',
	'Wagtail',
	'Starling',
	'Macaw',
	'Cockatoo',
	'Heron',
	'Toucan',
	'Jay',
	'Mynah',
	'Cardinal',
	'Chickadee',
	'Junco',
	'Bluebird',
	'Swift',
	'Gull',
	'Lovebird',
	'Spoonbill',
	'Kiwi',
	'Avocet',
	'Wren',
	'Mockingbird',
	'Pheasant',
	'Hoopoe',
	'Kite',
	'Peahen',
	'Falcon',
	'Mallard',
	'Tern',
	'Crossbill',
	'Lapwing',
	'Puffin',
	'Koyal',
	'Bullfinch',
	'Emu',
	'Condor',
]

const colors = [
	'Brown',
	'Chocolate',
	'Coral',
	'Crimson',
	'Fuchsia',
	'Gray',
	'Green',
	'Indigo',
	'Maroon',
	'Olive',
	'Orange',
	'Orchid',
	'Pink',
	'Plum',
	'Purple',
	'Salmon',
	'Sienna',
	'Silver',
	'Tan',
	'Teal',
	'Thistle',
	'Tomato',
	'Turquoise',
	'Violet',
	'Red',
	'Yellow',
]

export default function generateBirdName(seed = Math.random()) {
	const color = colors[Math.floor(Math.random(seed) * colors.length)]
	const bird = birds[Math.floor(Math.random(seed) * birds.length)]
	return `${color} ${bird}`
}
